export const IDebugRepositoryType = Symbol('IDebugRepository');
